import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/store'

Vue.use(VueRouter)

const routes = [
  { path: '*', redirect: '/login' }, // could be 404 error page

  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(
        /* webpackChunkName: "login" */ '@/views/Account/Auth/Login/Login'
      ),
    meta: { guest: true }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () =>
      import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/Dashboard'),
    meta: { authenticated: true, translator: false }
  },
  {
    path: '/candidates',
    name: 'candidates',
    component: () =>
      import(/* webpackChunkName: "tables" */ '@/views/Candidates/Candidates'),
    meta: { authenticated: true, translator: false }
  },
  {
    path: '/recruiters',
    name: 'recruiters',
    component: () =>
      import(/* webpackChunkName: "tables" */ '@/views/Recruiters/Recruiters'),
    meta: { authenticated: true, translator: false }
  },
  {
    path: '/registration-exceptions',
    name: 'registration-exceptions',
    component: () =>
      import(
        /* webpackChunkName: "tables" */ '@/views/RegistrationExceptions/RegistrationExceptions'
      ),
    meta: { authenticated: true, translator: false }
  },
  {
    path: '/matchmaking',
    name: 'matchmaking',
    component: () =>
      import(
        /* webpackChunkName: "matchmaking" */ '@/views/Matchmaking/Matchmaking'
      ),
    meta: { authenticated: true, translator: false }
  },
  {
    path: '/activity',
    name: 'activity',
    component: () =>
      import(/* webpackChunkName: "activity" */ '@/views/Activity/Activity'),
    meta: { authenticated: true, translator: false }
  },
  {
    path: '/email-signature',
    name: 'email-signature',
    component: () =>
      import(
        /* webpackChunkName: "email" */ '@/views/EmailSignature/EmailSignature'
      ),
    meta: { authenticated: true, translator: false }
  },
  {
    path: '/comparison',
    name: 'comparison',
    component: () =>
      import(
        /* webpackChunkName: "email" */ '@/views/TestComparison/TestComparison'
      ),
    meta: { authenticated: true, translator: false }
  },
  {
    path: '/comparison/data',
    name: 'comparison-data',
    component: () =>
      import(
        /* webpackChunkName: "email" */ '@/views/TestComparisonDummy/TestComparisonDummy'
      ),
    meta: { authenticated: true, translator: false }
  },
  {
    path: '/translate/dashboard',
    name: 'translate-dashboard',
    component: () =>
      import(/* webpackChunkName: "email" */ '@/views/Translate/Dashboard'),
    meta: { authenticated: true, translator: true }
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: () =>
      import(
        /* webpackChunkName: "email" */ '@/views/Notifications/Notifications'
      ),
    meta: { authenticated: true, translator: false }
  },
  {
    path: '/advanced-report',
    name: 'advanced-report',
    component: () =>
      import(
        /* webpackChunkName: "email" */ '@/views/AdvReport/AdvReport'
      ),
    meta: { authenticated: true, translator: false }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async(to, from, next) => {
  if (!store.getters.isAuthenticated) {
    await store.dispatch('tryAutoLogin', {
      route: to
    })

    if (!store.getters.isAuthenticated) {
      await store.dispatch('getGuestToken')
    }
  }

  // Authentication guards
  if (store.getters.isAuthenticated && to.matched.some((record) => record.meta.guest)) {
    if (store.getters.isTranslator && !store.getters.isOwiwi && to.matched.some((record) => record.meta.translator)) {
      next({ path: '/translate/dashboard' })
      return
    }
    next({ path: '/dashboard' })
    return
  }
  else if (!store.getters.isAuthenticated && to.matched.some((record) => record.meta.authenticated)) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
    return
  }
  else if (store.getters.isAuthenticated && store.getters.isTranslator && !store.getters.isOwiwi && to.matched.some((record) => !record.meta.translator)) {
    next({ path: '/translate/dashboard' })
    return
  }

  next()
})

export default router
